<template>
  <li class="catalog__item" >
    <router-link class="catalog__pic" :to="{name: 'product', params: {id: product.id}}">
      <img v-bind:src="product.image" v-bind:alt="product.title">
    </router-link>

    <h3 class="catalog__title">
      <a href="#">
        {{ product.title }}
      </a>
    </h3>

    <span class="catalog__price">
      {{ product.price | numberFormat }} ₽
    </span>

    <ul class="colors colors--black">
      <li class="colors__item" v-for="product in product.colors" :key="product.id">
        <label class="colors__label">
          <input class="colors__radio sr-only"
          type="radio" :value="product" v-model="currentColor">
          <span class="colors__value" :style="{'background-color': product.code}">
          </span>
        </label>
      </li>
    </ul>
  </li>
</template>

<script>
import gotoPage from '../helpers/gotoPage';
import numberFormat from '../helpers/numberFormat';

export default {
  filters: {
    numberFormat,
  },
  methods: {
    gotoPage,
  },
  data() {
    return {
      idNumber: 13,
      currentColor: '',
    };
  },
  props: ['product'],
};
</script>
